import { render, staticRenderFns } from "./HchospitalizacionDesktop.vue?vue&type=template&id=7b22e87f&scoped=true"
import script from "./HchospitalizacionDesktop.vue?vue&type=script&lang=js"
export * from "./HchospitalizacionDesktop.vue?vue&type=script&lang=js"
import style0 from "./HchospitalizacionDesktop.vue?vue&type=style&index=0&id=7b22e87f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b22e87f",
  null
  
)

export default component.exports